import React, {useState, useEffect} from "react";
import TablesList from "./TablesList";
import TableEditor from "./TableEditor";
import ConfirmationDialog from "../Common/ConfirmationDialog";
import Notification from "../Common/Notification";

const TablesSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [showEditor, setShowEditor] = useState(false);
    const [currentTable, setCurrentTable] = useState(null);
    const [notification, setNotification] = useState({
        show: false,
        type: 'success',
        message: '',
    });
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Function to show a notification
    const showNotification = (type, message) => {
        setNotification({
            show: true,
            type,
            message,
        });

        if (type === 'success') {
            setTimeout(() => {
                setNotification(prev => ({...prev, show: false}));
            }, 5000);
        }
    };

    // Function to hide notification
    const hideNotification = () => {
        setNotification(prev => ({...prev, show: false}));
    };

    // Handle create new table
    const handleCreateTable = () => {
        setCurrentTable(null);
        setShowEditor(true);
    };

    // Handle edit table
    const handleEditTable = (table) => {
        setCurrentTable(table);
        setShowEditor(true);
    };

    // Handle back from editor
    const handleCloseEditor = () => {
        setShowEditor(false);
        setCurrentTable(null);
    };

    // Handle deletion confirmation
    const handleDeleteSelected = () => {
        if (selectedItems.length > 0) {
            setShowConfirmDialog(true);
        }
    };

    // Function to confirm deletion
    const confirmDelete = () => {
        setShowConfirmDialog(false);
        // Deletion will be handled by the TablesList component
    };

    // Function to cancel deletion
    const cancelDelete = () => {
        setShowConfirmDialog(false);
    };

    return (
        <div>
            <TablesList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
                showNotification={showNotification}
                onCreateTable={handleCreateTable}
                onEditTable={handleEditTable}
                onDeleteSelected={handleDeleteSelected}
            />

            {showEditor && (
                <TableEditor
                    table={currentTable}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {/* Confirmation Dialog */}
            {showConfirmDialog && (
                <ConfirmationDialog
                    title="Confirmation de suppression"
                    message={`Êtes-vous sûr de vouloir supprimer ${selectedItems.length} table${selectedItems.length > 1 ? 's' : ''} ? Cette action est irréversible.`}
                    confirmLabel="Confirmer"
                    cancelLabel="Annuler"
                    onConfirm={confirmDelete}
                    onCancel={cancelDelete}
                    danger={true}
                />
            )}

            {/* Notification */}
            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default TablesSettings;
